import { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "../../../styles/panel/user/TicketDetail.css";
import { useAuth } from "../../../context/AuthContext";
import { getTicketDetail, sendMessage } from "../../../api/support";
import {
  Icon,
  BACK_ICON,
  ATTACH_BTN,
} from "./manageShop/shared/EditShopShared";
import moment, { from } from "jalali-moment";
import { API_BASE_URL } from "../../../api/http";

// الگوی پس‌زمینه چت (آیکن‌های فروشگاه/پشتیبانی هماهنگ با تم بنفش پنل)
const CHAT_BG_PATTERN_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="360" height="360" viewBox="0 0 360 360"><defs><g id="ic-bag"><path d="M14 20 L46 20 L50 56 L10 56 Z"/><path d="M22 20 C22 8 38 8 38 20"/></g><g id="ic-cart"><path d="M6 8 L14 8 L22 42 L48 42 L54 18 L18 18"/><circle cx="22" cy="52" r="4.5"/><circle cx="46" cy="52" r="4.5"/></g><g id="ic-shop"><path d="M6 22 L10 6 L46 6 L50 22"/><path d="M6 22 C6 28 14 28 14 22 C14 28 22 28 22 22 C22 28 30 28 30 22 C30 28 38 28 38 22 C38 28 46 28 46 22 C46 28 50 28 50 22"/><path d="M10 24 L10 50 L46 50 L46 24"/><path d="M22 50 L22 34 L34 34 L34 50"/></g><g id="ic-site"><rect x="6" y="10" width="48" height="38" rx="4"/><path d="M6 20 L54 20"/><circle cx="13" cy="15" r="1.5" fill="currentColor" stroke="none"/><circle cx="19" cy="15" r="1.5" fill="currentColor" stroke="none"/><circle cx="25" cy="15" r="1.5" fill="currentColor" stroke="none"/><path d="M14 30 L34 30 M14 38 L46 38"/></g><g id="ic-person"><circle cx="28" cy="16" r="10"/><path d="M8 52 C8 34 48 34 48 52"/></g><g id="ic-chat"><path d="M8 10 H48 A6 6 0 0 1 54 16 V38 A6 6 0 0 1 48 44 H24 L12 54 V44 H8 A6 6 0 0 1 2 38 V16 A6 6 0 0 1 8 10 Z" transform="translate(2,0)"/><circle cx="18" cy="26" r="1.6" fill="currentColor" stroke="none"/><circle cx="28" cy="26" r="1.6" fill="currentColor" stroke="none"/><circle cx="38" cy="26" r="1.6" fill="currentColor" stroke="none"/></g><g id="ic-heart"><path d="M28 50 C6 34 6 16 18 10 C24 7 28 12 28 16 C28 12 32 7 38 10 C50 16 50 34 28 50 Z"/></g><g id="ic-star"><path d="M28 6 L34 22 L51 22 L37 32 L42 49 L28 39 L14 49 L19 32 L5 22 L22 22 Z"/></g><g id="ic-tag"><path d="M8 8 L28 8 L50 30 L30 50 L8 28 Z"/><circle cx="17" cy="17" r="3"/></g><g id="ic-gift"><rect x="8" y="22" width="40" height="30" rx="3"/><path d="M8 32 L48 32"/><path d="M28 22 L28 52"/><path d="M28 22 C16 22 16 8 24 8 C30 8 30 18 28 22 C26 18 26 8 32 8 C40 8 40 22 28 22 Z"/></g><g id="ic-headset"><path d="M8 30 C8 12 48 12 48 30"/><rect x="4" y="28" width="10" height="16" rx="4"/><rect x="42" y="28" width="10" height="16" rx="4"/><path d="M47 44 V48 C47 52 43 54 38 54"/></g><g id="ic-mail"><rect x="6" y="12" width="44" height="32" rx="4"/><path d="M6 15 L28 34 L50 15"/></g><g id="ic-shield"><path d="M28 6 L48 14 V26 C48 40 38 47 28 51 C18 47 8 40 8 26 V14 Z"/><path d="M18 27 L25 34 L38 20"/></g><g id="ic-clip"><path d="M34 10 L17 27 C12 32 12 39 17 44 C22 49 29 49 34 44 L47 31 C50 28 50 23 47 20 C44 17 39 17 36 20 L23 33 C21.5 34.5 21.5 37 23 38.5 C24.5 40 27 40 28.5 38.5 L40 27"/></g><g id="ic-help"><path d="M8 10 H48 A6 6 0 0 1 54 16 V38 A6 6 0 0 1 48 44 H24 L12 54 V44 H8 A6 6 0 0 1 2 38 V16 A6 6 0 0 1 8 10 Z" transform="translate(2,0)"/><path d="M22 22 C22 16 32 16 32 22 C32 26 27 26 27 31" /><circle cx="27" cy="37" r="1.6" fill="currentColor" stroke="none"/></g><g id="tile" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round" color="#522B5B" opacity="0.08"><use href="#ic-bag" transform="translate(14,10) rotate(-10) scale(0.62)"/><use href="#ic-site" transform="translate(96,4) rotate(7) scale(0.6)"/><use href="#ic-star" transform="translate(176,18) rotate(14) scale(0.5)"/><use href="#ic-mail" transform="translate(240,8) rotate(-6) scale(0.6)"/><use href="#ic-clip" transform="translate(310,20) rotate(20) scale(0.55)"/><use href="#ic-person" transform="translate(30,66) rotate(-6) scale(0.58)"/><use href="#ic-headset" transform="translate(112,62) rotate(5) scale(0.6)"/><use href="#ic-chat" transform="translate(190,70) rotate(-8) scale(0.6)"/><use href="#ic-shop" transform="translate(266,64) rotate(9) scale(0.6)"/><use href="#ic-heart" transform="translate(20,132) rotate(12) scale(0.5)"/><use href="#ic-tag" transform="translate(90,126) rotate(-14) scale(0.56)"/><use href="#ic-shield" transform="translate(160,124) rotate(6) scale(0.58)"/><use href="#ic-cart" transform="translate(236,128) rotate(-9) scale(0.58)"/><use href="#ic-gift" transform="translate(306,132) rotate(11) scale(0.55)"/><use href="#ic-help" transform="translate(50,190) rotate(-8) scale(0.56)"/><use href="#ic-site" transform="translate(140,188) rotate(9) scale(0.55)"/><use href="#ic-star" transform="translate(214,196) rotate(-13) scale(0.48)"/><use href="#ic-person" transform="translate(280,190) rotate(7) scale(0.55)"/><use href="#ic-bag" transform="translate(10,252) rotate(8) scale(0.58)"/><use href="#ic-chat" transform="translate(80,256) rotate(-11) scale(0.55)"/><use href="#ic-headset" transform="translate(158,250) rotate(6) scale(0.55)"/><use href="#ic-mail" transform="translate(232,254) rotate(-7) scale(0.55)"/><use href="#ic-heart" transform="translate(304,256) rotate(13) scale(0.48)"/><use href="#ic-shop" transform="translate(40,306) rotate(-6) scale(0.55)"/><use href="#ic-tag" transform="translate(116,312) rotate(10) scale(0.5)"/><use href="#ic-cart" transform="translate(190,308) rotate(-8) scale(0.55)"/><use href="#ic-clip" transform="translate(262,314) rotate(15) scale(0.5)"/><use href="#ic-star" transform="translate(330,306) rotate(-10) scale(0.46)"/><use href="#ic-shield" transform="translate(56,40) rotate(18) scale(0.4)"/><use href="#ic-tag" transform="translate(136,38) rotate(-16) scale(0.38)"/><use href="#ic-heart" transform="translate(210,44) rotate(10) scale(0.36)"/><use href="#ic-gift" transform="translate(276,36) rotate(-12) scale(0.4)"/><use href="#ic-cart" transform="translate(340,48) rotate(8) scale(0.36)"/><use href="#ic-mail" transform="translate(70,96) rotate(-9) scale(0.38)"/><use href="#ic-star" transform="translate(150,98) rotate(15) scale(0.34)"/><use href="#ic-shop" transform="translate(226,94) rotate(-11) scale(0.38)"/><use href="#ic-help" transform="translate(296,98) rotate(9) scale(0.36)"/><use href="#ic-bag" transform="translate(60,160) rotate(-13) scale(0.4)"/><use href="#ic-person" transform="translate(132,158) rotate(11) scale(0.36)"/><use href="#ic-chat" transform="translate(206,162) rotate(-8) scale(0.38)"/><use href="#ic-clip" transform="translate(278,160) rotate(14) scale(0.36)"/><use href="#ic-site" transform="translate(24,222) rotate(9) scale(0.38)"/><use href="#ic-headset" transform="translate(98,224) rotate(-14) scale(0.36)"/><use href="#ic-shield" transform="translate(172,220) rotate(10) scale(0.38)"/><use href="#ic-tag" transform="translate(246,226) rotate(-9) scale(0.36)"/><use href="#ic-heart" transform="translate(320,222) rotate(12) scale(0.34)"/><use href="#ic-gift" transform="translate(58,284) rotate(-10) scale(0.38)"/><use href="#ic-cart" transform="translate(130,282) rotate(13) scale(0.36)"/><use href="#ic-mail" transform="translate(202,286) rotate(-11) scale(0.36)"/><use href="#ic-star" transform="translate(272,284) rotate(9) scale(0.34)"/><use href="#ic-shop" transform="translate(342,282) rotate(-13) scale(0.36)"/></g></defs><rect width="360" height="360" fill="none"/><use href="#tile"/></svg>`;
const CHAT_BODY_STYLE = {
  backgroundImage: `url("data:image/svg+xml,${encodeURIComponent(CHAT_BG_PATTERN_SVG)}")`,
};

// آدرس پایه‌ی سرور برای عکس‌هایی که مسیرشون نسبیه (بدون دامنه).
// این متغیر رو خودت از جایی که تعریفش کردی import کن.

// اگه مسیر عکس از سرور کامل نباشه (مسیر نسبی مثل "/media/xyz.png")،
// API_BASE_URL رو بهش اضافه می‌کنه. اگه از قبل کامل بود (http/https/data)
// یا اصلاً مقداری نداشت، همون رو برمی‌گردونه.
function resolveImageUrl(url) {
  if (!url) return url;
  if (/^(https?:)?\/\//.test(url) || url.startsWith("data:")) return url;
  return `${API_BASE_URL}${url.startsWith("/") ? "" : "/"}${url}`;
}

function formatTime(dateString) {
  if (!dateString) return "";
  return moment(dateString).locale("fa").format("HH:mm");
}

function formatDateDivider(dateString) {
  if (!dateString) return "";
  return moment(dateString).locale("fa").format("D MMMM YYYY");
}

// اگر پیام‌ها بین چند روز پخش باشند، جداکننده تاریخ بین آن‌ها نمایش داده می‌شود
function withDateDividers(messages) {
  const out = [];
  let lastDay = null;
  for (const m of messages) {
    const day = m.created_at ? moment(m.created_at).format("YYYY-MM-DD") : null;
    if (day && day !== lastDay) {
      out.push({
        type: "divider",
        key: `divider-${day}`,
        label: formatDateDivider(m.created_at),
      });
      lastDay = day;
    }
    out.push({ type: "message", key: m.id, data: m });
  }
  return out;
}

export default function TicketDetail() {
  const { ticketId } = useParams();
  const navigate = useNavigate();
  const { user } = useAuth();
  const [ticket, setTicket] = useState(null);
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [text, setText] = useState("");
  const [attachments, setAttachments] = useState([]);
  const [sending, setSending] = useState(false);
  const [sendError, setSendError] = useState(null);

  const fileInputRef = useRef(null);
  const bodyRef = useRef(null);
  const pageRef = useRef(null);

  const [previewImage, setPreviewImage] = useState(null);

  // وقتی روی composer فوکوس میشه، محل دقیق بالای صفحه رو *قبل* از باز شدن
  // کیبورد (و قبل از هر اسکرول خودکار مرورگر) ذخیره می‌کنیم. بعد با باز
  // شدن کیبورد، فقط "ارتفاع" صفحه رو کم می‌کنیم (نه موقعیتش رو) تا هدر
  // دقیقاً سرجای خودش بمونه و فقط composer به سمت بالا (روی کیبورد) جمع بشه.
  useEffect(() => {
    const vv = window.visualViewport;
    const pageEl = pageRef.current;
    if (!vv || !pageEl) return;

    let topOffset = null;

    const captureTopOffset = () => {
      topOffset = pageEl.getBoundingClientRect().top;
    };

    const isKeyboardOpen = () => window.innerHeight - vv.height > 80;

    const syncHeight = () => {
      if (topOffset === null) return;
      if (isKeyboardOpen()) {
        pageEl.style.height = `${vv.height - topOffset}px`;
      } else {
        pageEl.style.height = "";
        topOffset = null;
      }
    };

    const handleFocusIn = (e) => {
      const tag = e.target?.tagName;
      if (tag === "TEXTAREA" || tag === "INPUT") {
        captureTopOffset();
      }
    };

    pageEl.addEventListener("focusin", handleFocusIn);
    vv.addEventListener("resize", syncHeight);

    return () => {
      pageEl.removeEventListener("focusin", handleFocusIn);
      vv.removeEventListener("resize", syncHeight);
      pageEl.style.height = "";
    };
  }, []);

  useEffect(() => {
    if (!previewImage) return;
    const handleKeyDown = (e) => {
      if (e.key === "Escape") setPreviewImage(null);
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [previewImage]);

  const fetchTicket = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await getTicketDetail(ticketId);
      setTicket(res.data);
      setMessages(res.data.messages ?? []);
    } catch {
      setError("خطا در دریافت اطلاعات تیکت.");
    } finally {
      setLoading(false);
    }
  }, [ticketId]);

  useEffect(() => {
    fetchTicket();
  }, [fetchTicket]);

  useEffect(() => {
    bodyRef.current?.scrollTo({
      top: bodyRef.current.scrollHeight,
      behavior: "smooth",
    });
  }, [messages]);

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files ?? []);
    setAttachments((prev) => [...prev, ...files]);
    setSendError(null);
    e.target.value = "";
  };

  const removeAttachment = (index) => {
    setAttachments((prev) => prev.filter((_, i) => i !== index));
  };

  const handleSend = async () => {
    if (!text.trim()) {
      setSendError("لطفاً متن پیام را وارد کنید.");
      return;
    }
    setSending(true);
    setSendError(null);
    try {
      const formData = new FormData();
      formData.append("body", text.trim());
      attachments.forEach((file) => formData.append("images", file));

      const res = await sendMessage(ticketId, formData);
      setMessages((prev) => [...prev, res.data]);
      setText("");
      setAttachments([]);
    } catch {
      setSendError("ارسال پیام با خطا مواجه شد. دوباره تلاش کنید.");
    } finally {
      setSending(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  const isClosed = ticket?.status === "closed";
  const rows = withDateDividers(messages);

  return (
    <div className="ticket-detail-page" ref={pageRef}>
      <div className="ticket-detail-header">
        <div className="ticket-detail-heading">
          <button
            type="button"
            className="esp-back-btn"
            onClick={() => navigate("/panel/user/ticket-archive")}
            aria-label="بازگشت به لیست تیکت‌ها"
          >
            <Icon>{BACK_ICON}</Icon>
          </button>
          <div>
            <div className="ticket-detail-title">{ticket?.title ?? "تیکت"}</div>
            <div className="ticket-detail-subtitle">
              فروشگاه : {ticket?.store}
            </div>
          </div>
        </div>
        {ticket && (
          <span className={`status-badge ${ticket.status}`}>
            {/* <span className="status-dot" /> */}
            {ticket.status === "open" ? "باز" : "بسته"}
          </span>
        )}
      </div>

      <div className="ticket-chat-wrap">
        <div className="ticket-chat-body" ref={bodyRef} style={CHAT_BODY_STYLE}>
          {loading ? (
            <div className="chat-empty">در حال بارگذاری...</div>
          ) : error && messages.length === 0 ? (
            <div className="chat-empty">{error}</div>
          ) : messages.length === 0 ? (
            <div className="chat-empty">پیامی وجود ندارد.</div>
          ) : (
            rows.map((row) =>
              row.type === "divider" ? (
                <div key={row.key} className="chat-date-divider">
                  <span>{row.label}</span>
                </div>
              ) : (
                <div
                  key={row.key}
                  className={`chat-bubble-row${row.data.sender === user?.id ? " own" : ""}`}
                >
                  <div className="chat-bubble">
                    {row.data.body && (
                      <div className="chat-bubble-text">{row.data.body}</div>
                    )}
                    {row.data.attachments?.length > 0 && (
                      <div className="chat-bubble-attachments">
                        {row.data.attachments.map((a) => (
                          <button
                            key={a.id}
                            type="button"
                            className="chat-attachment-item"
                            onClick={() => setPreviewImage(a)}
                          >
                            <img
                              src={resolveImageUrl(a.image)}
                              alt={a.name}
                              className="chat-attachment-img"
                              loading="lazy"
                            />
                            {a.name && (
                              <span className="chat-attachment-caption">
                                {a.name}
                              </span>
                            )}
                          </button>
                        ))}
                      </div>
                    )}
                    <div className="chat-bubble-time">
                      {formatTime(row.data.created_at)}
                    </div>
                  </div>
                </div>
              ),
            )
          )}
        </div>

        {isClosed ? (
          <div className="ticket-closed-note">
            این تیکت بسته شده است و امکان ارسال پیام جدید وجود ندارد.
          </div>
        ) : (
          <div className="ticket-composer">
            {sendError && <div className="composer-error">{sendError}</div>}

            {attachments.length > 0 && (
              <div className="composer-attachments">
                {attachments.map((file, i) => (
                  <div key={i} className="composer-attachment-chip">
                    <span>{file.name}</span>
                    <button
                      type="button"
                      onClick={() => removeAttachment(i)}
                      aria-label="حذف پیوست"
                    >
                      ×
                    </button>
                  </div>
                ))}
              </div>
            )}

            <div className="composer-row">
              <button
                type="button"
                className="attach-btn attach-btn-icon"
                onClick={() => fileInputRef.current?.click()}
                title="پیوست فایل"
              >
                <Icon>{ATTACH_BTN}</Icon>
              </button>
              <input
                ref={fileInputRef}
                type="file"
                multiple
                hidden
                onChange={handleFileChange}
              />
              <textarea
                className="composer-input"
                placeholder="پیام خود را بنویسید..."
                value={text}
                onChange={(e) => {
                  setText(e.target.value);
                  if (sendError) setSendError(null);
                }}
                onKeyDown={handleKeyDown}
                rows={1}
              />
              <button
                type="button"
                className="send-btn"
                onClick={handleSend}
                disabled={sending || !text.trim()}
              >
                {sending ? "..." : "ارسال"}
              </button>
            </div>
          </div>
        )}
      </div>

      {previewImage && (
        <div
          className="image-preview-overlay"
          onClick={() => setPreviewImage(null)}
        >
          <div
            className="image-preview-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              type="button"
              className="image-preview-close"
              onClick={() => setPreviewImage(null)}
              aria-label="بستن"
            >
              ×
            </button>
            <img
              src={resolveImageUrl(previewImage.image)}
              alt={previewImage.name}
              className="image-preview-img"
            />
            {previewImage.name && (
              <div className="image-preview-caption">{previewImage.name}</div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
